import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { UserForm } from '@app/components/forms/UserForm/UserForm';

const AddNewUser: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <PageTitle>{t('Add User')}</PageTitle>
      <UserForm type={"create"} editable={true} />
    </>
  );
};

export default AddNewUser;
